import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { reduxForm, change } from 'redux-form';
import { FormattedMessage, useIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import Button from 'react-bootstrap/lib/Button';
import FormControl from 'react-bootstrap/lib/FormControl';
import cx from 'classnames';

// Components
import DateRange from '../DateRange';
import PlaceGeoSuggest from '../../Common/GeoSuggest/PlaceGeoSuggest';
import MobileDateRange from '../MobileDateRange';

// Redux Action
import { setPersonalizedValues } from '../../../actions/personalized';

// Helper
import detectMobileBrowsers from '../../../helpers/detectMobileBrowsers';
import history from '../../../core/history';
import messages from '../../../locale/messages';
import { searchFormSuggestSelect, changeSearchForm } from '../../../helpers/GeoSuggest/updateSearchForm';

import searchIcon from '/public/SiteIcons/searchIconHome.svg';

import bt from '../../commonStyle.css';
import s from './SearchForm.css';

const SearchForm = ({ handleSubmit, isLoading, id }) => {
  const dispatch = useDispatch();
  const intl = useIntl();

  const personalized = useSelector(state => state.personalized);
  const listingFields = useSelector(state => state.listingFields.data);
  const settingsData = useSelector(state => state.viewListing.settingsData);

  const [mobileDevice, setMobileDevice] = useState(false);
  const [personCapacity, setPersonCapacity] = useState([]);
  const [smallDevice, setSmallDevice] = useState(false);
  const [verySmallDevice, setVerySmallDevice] = useState(false);
  const [isOneTotalToggle, setIsOneTotalToggle] = useState(false);

  useEffect(() => {
    if (detectMobileBrowsers.isMobile()) {
      setMobileDevice(true);
    }

    if (listingFields) {
      setPersonCapacity(listingFields.personCapacity);
    }

    if (personalized?.isOneTotalToggle) {
      setIsOneTotalToggle(true);
    }

    const handleResize = () => {
      setSmallDevice(window.matchMedia('(max-width: 767px)').matches);
      setVerySmallDevice(window.matchMedia('(max-width: 480px)').matches);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [listingFields, personalized]);

  const handleClick = () => {
    let uri = '/s?';

    if (personalized?.chosen) {
      uri += `&address=${personalized.location}&chosen=${personalized.chosen}`;
    } else if (personalized?.location) {
      uri += `&address=${personalized.location}`;
    }

    if (personalized?.startDate && personalized?.endDate) {
      dispatch(setPersonalizedValues({ name: 'isOneTotalToggle', value: true }));
      dispatch(change('SearchForm', 'isOneTotalToggle', true));
      uri += `&startdate=${personalized.startDate}&enddate=${personalized.endDate}`;
    }

    if (personalized?.personCapacity && !isNaN(personalized.personCapacity)) {
      uri += `&guests=${personalized.personCapacity}`;
    }

    history.push(encodeURI(uri));
  };

  const onSuggestSelect = (data, value) => {
    searchFormSuggestSelect({ data, setPersonalizedValues: (payload) => dispatch(setPersonalizedValues(payload)), value });
  };

  const onChange = (value) => {
    if (value === '') {
      changeSearchForm({ setPersonalizedValues: (payload) => dispatch(setPersonalizedValues(payload)), change: (form, field, val) => dispatch(change(form, field, val)) });
    }
  };

  const rows = [];
  if (personCapacity?.[0]?.startValue) {
    for (let i = personCapacity[0].startValue; i <= personCapacity[0].endValue; i++) {
      rows.push(<option value={i} key={i}>{i} {i > 1 ? personCapacity[0].otherItemName : personCapacity[0].itemName}</option>);
    }
  }

  return (
    <div className={'layout5Css'}>
      <div className={cx('homeSearchForm', 'verticalsearchform', 'layout5Searchform')}>
        <div className={cx(s.searchForm, 'searchForm')}>
          <div className={cx('tableCellRTL', 'layout5DateWidth', s.GeoSuggestMobileFormItem, s.sideBorder, 'sideBorder', 'geoSuggestSideBorder')}>
            <label className={cx(s.label, s.whereLabelPadding)}>
              <span><FormattedMessage {...messages.where} /></span>
            </label>
            <PlaceGeoSuggest
              placeholder={intl.formatMessage(messages.homeWhere)}
              className={cx(s.formControlInput, s.layout2LocationSuggestInput, s.input, 'newGeoSuggestInput', s.textEllipsis)}
              id={'homeSearch' + id}
              initialValue={personalized?.location}
              onChange={onChange}
              onSuggestSelect={onSuggestSelect}
              containerClass="layoutTwoAndFiveGeoSuggest"
            />
          </div>
          <div className={cx('layout5SearchformLocationTwo', 'layout5DateWidth', s.mobileFormItem, s.sideBorder, 'sideBorder')}>
            <label className={cx(s.label, s.dateLabel)}>
              <span><FormattedMessage {...messages.when} /></span>
            </label>
            <span className={cx('homeDate', s.formControlInput, s.input, 'homeDateAR', 'homeSerachDate')}>
              {!smallDevice ? (
                <DateRange formName={'HomeSearchForm'} numberOfMonths={2} isLoading={isLoading} />
              ) : (
                <MobileDateRange formName={'HomeSearchForm'} numberOfMonths={1} isLoading={isLoading} />
              )}
            </span>
          </div>
          <div className={s.mobileFormItem}>
            <label className={cx(s.selectPadding, s.label, 'inputSpace')}>
              <span><FormattedMessage {...messages.guest} /></span>
            </label>
            <FormControl
              componentClass="select"
              className={cx(s.formControlSelect, s.input, s.inputPadding, 'inputPaddingAR', 'inputSpace', 'inputPaddingRTL')}
              onChange={(e) => dispatch(setPersonalizedValues({ name: 'personCapacity', value: Number(e.target.value) }))}
              value={personalized?.personCapacity}
            >
              {rows}
            </FormControl>
          </div>
          <div className={s.buttonContainer}>
            <Button className={cx(bt.btnPrimary, s.btnBlock, s.searchButton, 'layOut5SearchBtn')} onClick={handleClick}>
              <img src={searchIcon} alt="Search" />
              <span><FormattedMessage {...messages.search} /></span>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

SearchForm.propTypes = {
  handleSubmit: PropTypes.func,
  isLoading: PropTypes.bool,
  id: PropTypes.any
};

export default reduxForm({
  form: 'HomeSearchForm',
})(withStyles(s, bt)(SearchForm));
